module.exports = __webpack_public_path__ + "img/logo_menu_noir.a67b4c62.png";